<cc-box class="live-preview-box">
  <div box header>
    <div
      class="link"
      [ngClass]="{ active: state === 'BUBBLE'}"
      (click)="changeState('BUBBLE')">
      {{'LEAD_GENERATION.CREATOR.BUBBLE.BUBBLE' | translate }}
    </div>
    <div
      class="link"
      [ngClass]="{ active: state === 'BOX'}"
      (click)="changeState('BOX')">
      {{'LEAD_GENERATION.CREATOR.BUBBLE.BOX' | translate }}
    </div>
  </div>
  <div class="box-content" box content>
    <div class="iframe-wrapper">
      <iframe class="frame" [srcdoc]="previewHtml" id="widgetLive">
      </iframe>
    </div>
  </div>
</cc-box>

